import { APIs } from "../../util/api/APIs";
import SafeairManager from "../../util/api/SafeairManager";
import IFlightResponse, {
  DiversionDecisionStatus,
} from "./typings/IFlightResponse";

export class FlightService {
  static async listFlights(): Promise<IFlightResponse[]> {
    const apiConfig = {
      api: APIs.Flight.ListFlight,
      parameters: null,
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }

  static async getFlight(flightId: string,): Promise<IFlightResponse> {
    const apiConfig = {
      api: APIs.Flight.GetFlight,
      parameters: {
        "flight-id": flightId,
        
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }

  // static async recommendDiversion(flightId: string) {
  //   const apiConfig = {
  //     api: APIs.Flight.UpdateFlightDiversionStatus,
  //     parameters: {
  //       "flight-id": flightId,
  //       "diversion-status": DiversionDecisionStatus.DIVERSION_REQUIRED,
  //     },
  //     body: null,
  //   };
  //   const response = await SafeairManager.invoke(apiConfig);
  //   return response.data;
  // }

  static async updateFlightLastSeen(flightId: string) {
    const apiConfig = {
      api: APIs.Flight.UpdateFlightLastSeen,
      parameters: {
        "flight-id": flightId
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return;
  }
  static async getFlightRelatedToOrgId(orgId: string) {
    const apiConfig = {
      api: APIs.Flight.GetFlightByOrgId,
      parameters: {
        "organization-id": orgId
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }
  static async getOrgDrop(orgId: string) {
    const apiConfig = {
      api: APIs.Flight.GetDropDown,
      parameters: {
        "organization-id": orgId
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }
  static async getCrewRelatedToFlight(flightId: string) {
    const apiConfig = {
      api: APIs.Flight.GetCrewByFlightId,
      parameters: {
        "flight-id": flightId
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }
  
  static async updateFlightDisposition(flightId: string): Promise<IFlightResponse> {
    const apiConfig = {
      api: APIs.Flight.UpdateFlightDispositionStatus,
      parameters: {
        "flight-id": flightId,
        "disposition-status": true
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
   // alert(response.data)
    return response.data;
  }

  static async getReports(medicalEmergencyCard: number) {
    const apiConfig = {
      api: APIs.Report.reportList,
      parameters: {
        "medical-emergency-id": medicalEmergencyCard
      },
      body: null,
    };
    const response = await SafeairManager.invoke(apiConfig);
    return response.data;
  }
}
